export default "__VITE_ASSET__CmdCYFG3__"